import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const easeExpo = [0.16, 1, 0.3, 1];

export function LineMask({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  inView = false,
}) {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, amount: 0.4 });
  const active = inView ? seen : true;

  return (
    <span ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={active ? { y: 0 } : { y: "115%" }}
            transition={{ duration: 1.05, delay: delay + i * 0.13, ease: easeExpo }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeIn({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.95, delay, ease: easeExpo }}
    >
      {children}
    </motion.div>
  );
}
